import { useMemo } from "react";
import { Grid, Stack } from '@mui/material';
import dayjs from "dayjs";
import { useFetch } from "../hooks/useFetch";
import { Aggregated, IDashboardDataItem, IResponse } from "./DashboardModel";
import DashboardCard from "./DashboardCard";

var localizedFormat = require("dayjs/plugin/localizedFormat");
dayjs.extend(localizedFormat);

export interface IDashboardCardsProps {
    dateFrom?: string;
    dateTo?: string;
    tabIndex : number;
}

function DashboardCards(props : IDashboardCardsProps) {
    const data = useFetch<IResponse | undefined>(`/api/maincontrol/TuiFlyCamService.svc/GetDashboardData?from=${props.dateFrom}&to=${props.dateTo}`, (response) => response, 0, true).data;
    
    const aggregateByKey = (items: IDashboardDataItem[]) : Aggregated[] => {
            const map = new Map<string, Aggregated>();
    
            for (const it of items) {
                const v = Number(it.Value) || 0;
                const existing = map.get(it.Key);
                if (existing) {
                existing.Value += v;
                } else {
                map.set(it.Key, { Key: it.Key, Name: it.Name, Value: v, Subtitle: it.Subtitle });
                }
            }
    
            return Array.from(map.values());
        }
    
        const aggregatedData = useMemo(() => {
            var list = (data?.Payload ?? []).map(o => { return { ...o, Subtitle: '' }});
    
            switch(props.tabIndex) {
                case 1: // TUI Airways
                    list = list.filter(o => (o.ClientCode ?? 'BAL').toUpperCase() === 'BAL');
                    break;
                case 2: // TUIfly BE
                    list = list.filter(o => (o.ClientCode ?? 'JAF').toUpperCase() === 'JAF');
                    break;
                case 3: // TUIfly Germany
                    list = list.filter(o => (o.ClientCode ?? 'TUI').toUpperCase() === 'TUI');
                    break;
                case 4: // TUIfly NL
                    list = list.filter(o => (o.ClientCode ?? 'TFL').toUpperCase() === 'TFL');
                    break;
                case 5: // TUIfly Nordic
                    list = list.filter(o => (o.ClientCode ?? 'BLX').toUpperCase() === 'BLX');
                    break;
                default:
                    // no filter
            }
    
            return aggregateByKey(list)
        }, [data, props.tabIndex])

    return (
        <Grid container spacing={3} marginLeft={0} marginTop={0.0}>
            <Stack direction='row' spacing={2} flexWrap='wrap' useFlexGap sx={{ marginBottom:2,
                    "& > *": {
                    width: 250,   // Fixed width to keep them sync on wrapping
                    flexShrink: 0 // Prevent shrinking
                    }
                }}>
                    { aggregatedData.map(o => (
                        <DashboardCard title={o.Name ?? 'Unkown'} subtitle={o.Subtitle ?? 'Unkown'} value={new Intl.NumberFormat("en-GB", { minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(o.Value)} />
                    ))}
                    
                </Stack>
        </Grid>
            
        
    );

};

export default DashboardCards;